/** @flow */

import React, { Component } from "react";
import Chart from "react-google-charts";
import classNames from "classnames";
import type { ChartWrapperOptions } from "react-google-charts";
import { chartDefaultColors } from "@styles/colors";

const lineOptions: ChartWrapperOptions = {
  legend: {
    position: "bottom",
  },
  chartArea: {
    top: 40,
  },
  hAxis: { showTextEvery: 1 }, // How many horizontal axis labels to show, where 1 means show every label, 2 means show every other label, and so on. Default is to try to show as many labels as possible without overlapping.
  colors: chartDefaultColors,
};

export type Props = $Exact<{
  options?: Object,
  title?: string,
  fullWidth?: boolean,
  disableBorder?: boolean,
  values: Array<Array<string | number | Object>>,
  legendToggle?: boolean,
  chartProps?: Object,
}>;

export class LineChart extends Component<Props> {
  static defaultProps = {
    options: {},
  };

  chartWrapper = null;

  onResize = () => {
    this.chartWrapper && this.chartWrapper.draw();
  };
  componentDidMount() {
    window.addEventListener("resize", this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize);
  }

  render() {
    return (
      <div
        className={classNames("item-container chart-block line-chart mt-3 pt-3", {
          "full-width": this.props.fullWidth,
          "disable-border": this.props.disableBorder,
        })}
      >
        {this.props.title && <div className="chart-title mb-2 text-center">{this.props.title}</div>}
        <Chart
          {...this.props.chartProps}
          chartType="LineChart"
          data={this.props.values}
          getChartWrapper={chartWrapper => {
            this.chartWrapper = chartWrapper;
          }}
          options={{ ...lineOptions, ...this.props.options }}
          legendToggle={this.props.legendToggle}
        />
      </div>
    );
  }
}

export default LineChart;
